import { Box } from 'braid-design-system';
import React from 'react';

import * as styles from './SkeletonBlock.css';

export type SkeletonBlockVariant = keyof typeof styles.variant;
type SkeletonBlockWidth = keyof typeof styles.width;
type SkeletonBlockHeight = keyof typeof styles.height;

export interface SkeletonBlockProps {
  width: SkeletonBlockWidth;
  variant: SkeletonBlockVariant;
  height?: SkeletonBlockHeight;
}

export const SkeletonBlock = ({
  width,
  variant,
  height = 'standard',
}: SkeletonBlockProps) => {
  const blockStyles = [
    styles.block,
    styles.width[width],
    styles.height[height],
    styles.variant[variant],
  ];

  return <Box className={blockStyles} />;
};
